'use strict';
{
    angular.module('tf.terms', []).constant('terms', {
        ivRank: {
            "name": "ivRank",
            "title": "IV Rank",
            "see": "",
            "description": "Implied Volatility Rank (IV Rank, or IV Percentile) helps us understand where IV is in relation to normal movement. A high IV rank shows that the Implied Volatility is at the highest levels over the last 52 weeks, whereas a low IV rank shows that Implied Volatility is cheap compared to the average. As implied volatility is cyclical, we generally look to sell options when IV rank is high, and buy options when IV rank is low to increase our chances of profiting from the options market. "
        },
        pnl: {
            "name": "pnl",
            "title": "Total unrealised P/L",
            "see": "",
            "description": "Estimated Unrealised Profit and Loss of the current open positions."
        },
        todaypnl: {
            "name": "todaypnl",
            "title": "Today's P/L",
            "see": "",
            "description": "Estimated Unrealised Profit and Loss of the current open positions today."
        },
        newBusiness: {
            "name": "newBusiness",
            "title": "New Business",
            "see": "",
            "description": "Premium value of positions traded today."
        },
        collAdj: {
            "name": "collAdj",
            "title": "Adjustment to Shortage or Excess",
            "see": "",
            "description": "This adjustment occurs where there is a cash ledger shortage as a result of a what-if trade, or vice versa. This figure represents the change to the collateral usage, to balance out the new shortage or excess."
        },
        callOption: {
            "name": "callOption",
            "title": "Call Option",
            "see": "",
            "description": "An agreement that allows the investor the right (but not the obligation) to buy a stock, index, or other instrument at a specified price (strike) at a predefined time in the future (expiry). A buyer of a call option would profit if the underlying asset was to increase."
        },
        putOption: {
            "name": "putOption",
            "title": "Put Option",
            "see": "",
            "description": "An agreement that allows the investor the right (but not the obligation) to sell a stock, index, or other instrument at a specified price (strike) at a predefined time in the future (expiry). A buyer of a put option would profit if the underlying asset was to decrease."
        },
        CMA: {
            "name": "CMA",
            "title": "CMA",
            "see": "",
            "description": "Cash Management Account value includes the balance of any linked cash management accounts, but does not include the value of cash in the ledger."
        },
        spanDelta: {
            "name": "spanDelta",
            "title": "Composite Delta",
            "see": "",
            "description": "Composite delta, or SPAN delta is an estimated delta value used for SPAN inter-commodity concession calculations. It is estimated by scanning across the SPAN sixteen scenarios, and weighting outcomes based on the likelihood of eventuating."
        },
        CVF: {
            "name": "CVF",
            "title": "Shares Per Contract",
            "see": "",
            "description": "CVF stands for Contract Value Factor, which is sometimes known as Shares Per Contract or contract size. This value is equivalent to the deliverable quantity of underlying shares or financial instruments delivered when exercised. For equity options listed on most exchanges, this is usually 100 shares per contract, which may be adjusted for rights, bonus issues and/or other capital adjustment events. Index options generally vary based on contract specifications of the exchange, for example XJO options listed on the ASX, have a contract size equivalent to $10 AUD for each point."
        },
        netDelta: {
            "name": "netDelta",
            "title": "Net Delta",
            "see": "",
            "description": "Net delta (or position delta), is the total dollar exposure of the position to the underlying security for every dollar of movement in the underlying. For example, a net delta of -100, means that for every dollar increase in the underlying stock, the option position is expected to lose $100."
        },
        netGamma: {
            "name": "netGamma",
            "title": "Net Gamma",
            "see": "",
            "description": "Gamma represents the rate of change of Delta with regards to the underlying price. Net gamma is the change to the net delta value for every dollar of movement in the underlying."
        },
        scanRisk: {
            "name": "scanRisk",
            "title": "Scan Risk",
            "see": "",
            "description": "Scan risk is equivalent to the largest loss for a security after scanning over sixteen different price and volatility scenarios determined by the exchange.   "
        },
        intrinsic: {
            "name": "intrinsic",
            "title": "Intrinsic Value",
            "see": "",
            "description": "The intrinsic value is the difference between the underlying's price and the strike price. " +
            "Intrinsic Value (Call) = Underlying Price - Strike Price.  " +
            "Intrinsic Value (Put) = Strike Price - Underlying Price.  "
        },
        moneyness: {
            "name": "moneyness",
            "title": "Moneyness",
            "see": "",
            "description": "The moneyness is the intrinsic value shown in terms of a percentage."
        },
        ledgerChangeMargin: {
            "name": "ledgerChangeMargin",
            "title": "Change in Margin",
            "see": "",
            "description": "The amount that total margin is estimated to change if the what-if trades in the active what-if tab were executed at the selected prices"
        },
        spanChange: {
            "name": "spanChange",
            "title": "SPAN Margin Change",
            "see": "",
            "description": "The change in SPAN margin between the estimated stressed scenario and the current SPAN margin. "
        },
        advChangeMarginDay: {
            "name": "advChangeMargin",
            "title": "CHG in Daily Margin",
            "see": "",
            "description": "The change in Total Margin since the previous end of day. "
        },
        advChangeMarginHour: {
            "name": "advChangeMargin",
            "title": "CHG in Hourly Margin",
            "see": "",
            "description": "The change in Total Margin since the latest hourly ASX update. "
        },
        cash: {
            "name": "cash",
            "title": "Cash",
            "see": "",
            "description": "The current balance of the linked bank account."
        },
        ledger: {
            "name": "ledger",
            "title": "Ledger",
            "see": "",
            "description": "The latest available combined balance of the equity (if connected) and options ledger."
        },
        etoLedger: {
            "name": "ledger",
            "title": "ETO Ledger",
            "see": "",
            "description": "The latest available balance of the options ledger. Please note, this balance appears from the perspective of the client."
        },
        equityLedger: {
            "name": "ledger",
            "title": "Equity Ledger",
            "see": "",
            "description": "The latest available balance of the equity ledger. Please note, this balance appears from the perspective of the client."
        },
        marginEffect: {
            "name": "marginEffect",
            "title": "Margin Effect",
            "see": "",
            "description": "The effect of closing the position on scan risk + premium margin adjusted for margin multiplier (if applicable). A positive value means that the position is contributing to margin, and closing it out will reduce overall scan risk and premium margin by this amount. Note that this does <b> not </b> include the effect on inter-commodity concession."
        },
        scanEffect: {
            "name": "scanEffect",
            "title": "Net Effect",
            "see": "",
            "description": "The anticipated net effect of closing that specific position, after taking into consideration premium paid/received and any margin changes (including inter-commodity concessions, scan risk, premium margin and additional margin)."
        },
        estProfit: {
            "name": "estProfit",
            "title": "Estimated P/L",
            "see": "",
            "description": "The estimated change in premium margin in the derivatives portfolio, symbolising unrealised capital gain (or loss) in the event of the stressed scenario eventuating."
        },
        shortfall: {
            "name": "shortfall",
            "title": "Shortfall",
            "see": "",
            "description": "The estimated shortfall of the portfolio to the broker (before any margin multipliers applied), in the event of a stress test scenario eventuating and no positions being changed or closed. This assumes the change in margin of the options portfolio, collateral (post-haircut) and any cash and/or cash management accounts. "
        },
        clientShortfall: {
            "name": "clientShortfall",
            "title": "Client Shortfall",
            "see": "",
            "description": "The estimated shortfall of the portfolio to the client (after any margin multipliers applied), in the event of a stress test scenario eventuating and no positions being changed or closed. This assumes the change in margin of the options portfolio, collateral (post-haircut) and any cash and/or cash management accounts. "
        },
        code: {
            "name": "code",
            "title": "Instrument Code",
            "see": "",
            "description": "The exchange generated name for the instrument. For example, ASX gives unique six character (sometimes five character) codes to all exchange traded options, with the first 3 representing the underlying stock."
        },
        expiry: {
            "name": "expiry",
            "title": "Expiry Date",
            "see": "",
            "description": "The last day that an options contract is valid. Depending on the exercise style of the option, the buyer may exercise his right at, or before this date at the predetermined strike price"
        },
        interConc: {
            "name": "interConc",
            "title": "I/C Concession",
            "see": "",
            "description": "The inter-commodity concession is the total value of margin credit applicable for positions in similar underlying instruments. Inter-commodity concessions use different inputs from the exchange to establish the total amount available to offset. These calculations are derived from taking volatility risk, price risk, time risk and the composite delta of each underlying security to establish whether offsets are possible. "
        },
        undPrice: {
            "name": "undPrice",
            "title": "Underlying Price",
            "see": "",
            "description": "The latest price of the underlying security, which is usually either the stock or the index from which the derivatives contract derives its value. "
        },
        adviser: {
            "name": "adviser",
            "title": "Adviser Code",
            "see": "",
            "description": "The adviser code that the account belongs to."
        },
        adviserName: {
            "name": "adviserName",
            "title": "Adviser Name",
            "see": "",
            "description": "The name of the adviser that the account belongs to."
        },

        branch: {
            "name": "branch",
            "title": "Branch Code",
            "see": "",
            "description": "The branch code that the account belongs to."
        },
        branchName: {
            "name": "branchName",
            "title": "Branch Name",
            "see": "",
            "description": "The name of the branch that the account belongs to."
        },
        scenario: {
            "name": "scenario",
            "title": "Scenario",
            "see": "",
            "description": "The name of the stressed scenario defined by the user."
        },
        accName: {
            "name": "accName",
            "title": "Account Name",
            "see": "",
            "description": "The name used by the account holder. It could be a personal name, or a company name."
        },
        ownerEmail: {
            "name": "ownerEmail",
            "title": "Email",
            "see": "",
            "description": "The email of the user that owns the account."
        },
        ownerPhone: {
            "name": "ownerPhone",
            "title": "Phone",
            "see": "",
            "description": "The phone number of the user that owns the account."
        },
        nlv: {
            "name": "nlv",
            "title": "NLV",
            "see": "",
            "description": "The Net Liquidation Value is the estimated value of complete liquidation of the portfolio, in the event of a stress test scenario eventuating. This assumes the total estimated market value of liquidating the options portfolio, collateral (pre-haircut) and any cash and/or cash management accounts. "
        },
        accNum: {
            "name": "accNum",
            "title": "Account Number",
            "see": "",
            "description": "The unique account number assigned to the account by the Clearing Participant."
        },
        premMargin: {
            "name": "premMargin",
            "title": "Premium Margin",
            "see": "",
            "description": "The premium margin (sometimes referred to as  net option value) is the estimated market value of a derivative position(s) using the latest theoretical prices, contract size and position size."
        },
        qty: {
            "name": "qty",
            "title": "Quantity",
            "see": "",
            "description": "The size of the position in contracts."
        },
        openPrice: {
            "name": "openPrice",
            "title": "Open Price",
            "see": "",
            "description": "The price at which the position was established on the market. "
        },
        openDate: {
            "name": "openDate",
            "title": "Open Date",
            "see": "",
            "description": "The date at which the position was opened. "
        },
        delta: {
            "name": "delta",
            "title": "Delta",
            "see": "",
            "description": "The ratio comparing the sensitivity of the option contract to the corresponding one dollar move of the underlying asset. A positive delta means that the price of the option will increase, and a negative delta means that the price of the option will decrease when the underlying asset goes up. The delta value changes over the life of the option based on volatility, time to expiry and the price of the underlying security."
        },
        gamma: {
            "name": "gamma",
            "title": "Gamma",
            "see": "",
            "description": "The second derivative of the option price with regards to price, or the ratio comparing the sensitivity of the option delta to the corresponding one dollar move of the underlying asset."
        },
        vega: {
            "name": "vega",
            "title": "Vega",
            "see": "",
            "description": "The ratio comparing the sensitivity of the option contract to the corresponding one percent move of the option volatility."
        },
        theta: {
            "name": "theta",
            "title": "Theta",
            "see": "",
            "description": "The ratio comparing the sensitivity of the option contract to the corresponding one day move of the options time to expiry."
        },
        netTheta: {
            "name": "netTheta",
            "title": "Net Theta",
            "see": "",
            "description": "The dollar-adjusted value of the time decay for the position per day."
        },
        rho: {
            "name": "rho",
            "title": "Rho",
            "see": "",
            "description": "The ratio comparing the sensitivity of the option contract to the corresponding one percent move of the risk free rate."
        },
        strike: {
            "name": "strike",
            "title": "Strike Price",
            "see": "",
            "description": "The strike price (or exercise price) is the price at which the derivative contract can be exercised. For call options, the buyer of the option has the right to buy the underlying security at the strike price, while for put options the buyer of the option has the right to sell at the strike price."
        },
        theoPrice: {
            "name": "theoPrice",
            "title": "Theoretical Price",
            "see": "",
            "description": "The theoretical price of an option is the predicted fair value derived by using a range of the latest parameters within options pricing models. These parameters include factors such as underlying price, time to expiry, strike price, interest rate, forecasted dividends and the volatility of the option. "
        },
        netEffect: {
            "name": "netEffect",
            "title": "Net Effect",
            "see": "",
            "description": "The total estimated cash impact on the portfolio (excl brokerage) of the what-if trade, assuming that each leg of the trade is executed at the theoretical price shown. This is the total of the cost of trade, less change in margin (including additional margin)."
        },
        initialMargin: {
            "name": "initialMargin",
            "title": "Initial Margin (ASX)",
            "see": "",
            "description": "TODO"
        },
        totalMargin: {
            "name": "totalMargin",
            "title": "Total Margin",
            "see": "",
            "description": "The total margin,<b> after </b>applying any applicable multipliers to the account. This is the total of premium margin and TradeFloor estimated SPAN margin for the account."
        },
        stressedTotalMargin: {
            "name": "stressedTotalMargin",
            "title": "Stressed Total Margin",
            "see": "",
            "description": ""
        },
        totalMarginChange: {
            "name": "totalMarginChange",
            "title": "Total Margin Change",
            "see": "",
            "description": ""
        },
        asxMargin: {
            "name": "asxMargin",
            "title": "ASX Margin",
            "see": "",
            "description": "The total margin using the latest ASX parameters,<b> before </b>any applicable multiplier for the account. This is the total value of premium margin and SPAN margin."
        },
        estMargin: {
            "name": "estMargin",
            "title": "Estimted Margin",
            "see": "",
            "description": "The TradeFloor estimated margin using the calculated theoretical prices using the latest provided underlying prices,<b> before </b>any applicable multiplier for the account. This value represents the total of premium margin and SPAN margin."
        },
        spanMargin: {
            "name": "spanMargin",
            "title": "SPAN Margin",
            "see": "",
            "description": "The total of Scan Risk, Intra-Commodity Spread Charge and Inter-Commodity concession."
        },
        stressedSpan: {
            "name": "stressedSpan",
            "title": "Stressed SPAN Margin",
            "see": "",
            "description": "The total of Scan Risk, Intra-Commodity Spread Charge and Inter-Commodity concession."
        },
        collateral: {
            "name": "collateral",
            "title": "Collateral",
            "see": "",
            "description": "The total value of collateral lodged, which includes stock that has been specifically marked as collateral (after the haircut applied to the holdings value by the exchange) and could include bank guarantees, if applicable. Stock lodged as specific cover as part of a covered call strategy does not appear here."
        },
        stressedCollateral: {
            "name": "stressedCollateral",
            "title": "Stressed Collateral",
            "see": "",
            "description": "The total estimated value of collateral lodged after the stressed scenario is applied, which includes stock that has been specifically marked as collateral (after the haircut applied to the holdings value by the exchange) and could include bank guarantees, if applicable. Stock lodged as specific cover as part of a covered call strategy does not appear here."
        },
        type: {
            "name": "type",
            "title": "Contract Type",
            "see": "",
            "description": "The type of the instrument in which the position is established. For options, the type shows if the position is a Put or a Call, and whether it is an American or European expiry. For example, Put - A means that the option is a put with an American-styled expiry."
        },
        security: {
            "name": "security",
            "title": "Underlying Security",
            "see": "",
            "description": "The underlying security of the position, which is usually either the stock or the index from which the derivatives contract derives its value. "
        },
        costTrade: {
            "name": "costTrade",
            "title": "Cost of Trade",
            "see": "",
            "description": "The estimated cost of the trade (excl brokerage) of the what-if trade(s), assuming that each leg of the trade is executed at the theoretical price shown. <b>Positive</b> value symbolises a net <b>credit</b> (cash <b>inflow</b>), negative value symbolises a net debit (cash outflow). "
        },
        cashMarginMovement: {
            "name": "cashMarginMovement",
            "title": "Cash Margin Movement",
            "see": "",
            "description": "The estimated change in ASX obligation since the start of the day. "
        },
        asxNetBalance: {
            "name": "asxNetBalance",
            "title": "Net Balance (ASX)",
            "see": "",
            "description": "TODO"
        },
        netBalance: {
            "name": "netBalance",
            "title": "Net Balance",
            "see": "",
            "description": "Net Balance is the estimate of the end-of-day adjustment to the ETO ledger based on the latest estimated ACH obligation, adjustment to collateral and movement in LEPO mark-to-market margin. Please note that this number will change with changes in underlying market conditions."
        },
        vol: {
            "name": "vol",
            "title": "Volatility",
            "see": "",
            "description": "This values shows the implied volatility of the option. Implied volatility represents the anticipated volatility of the underlying security over the life of the option. Implied volatility values will change as expectations of the future movements of the underlying stock change. Higher levels of implied volatility result in higher option premium."
        },
        addMargin: {
            "name": "addMargin",
            "title": "Additional Margin",
            "see": "",
            "description": "Where a margin multiplier is applied to an account, this is the value of margin that is added by the Clearing Participant to the ASX margin. "
        },
        currentShortage: {
            "name": "currentShortage",
            "title": "Current Shortage",
            "see": "",
            "description": "The current shortage/excess of the portfolio before any what-if trade(s) are taken into consideration."
        },
        ledgerShortage: {
            "name": "ledgerShortage",
            "title": "Shortage after what-if",
            "see": "",
            "description": "The anticipated result on shortage/excess assuming the what-if trade(s) are executed at market."
        },
        advShortage: {
            "name": "advShortage",
            "title": "Shortage/Excess",
            "see": "",
            "description": "Shortage/Excess shows the total cash and cash-equivalent position left unutilised after any applicable margins have been deducted (after margin-multiplier). A negative value indicates a cash shortage."
        },
        advEodShortage: {
            "name": "advEodShortage",
            "title": "EOD Shortage/Excess",
            "see": "",
            "description": "Shortage/Excess shows the total cash and cash-equivalent position left unutilised after any applicable margins have been deducted (after margin-multiplier). A negative value indicates a cash shortage."
        },
        stressedPremium: {
            "name": "stressedPremium",
            "title": "Stressed Prem Margin",
            "see": "",
            "description": "The stressed premium margin (sometimes referred to as  net option value) is the estimated market value of a derivative portfolio under the selected stressed condition. Premium margin is calculated as stressed theoretical price * contract size * quantity"
        },
        utilisation: {
            "name": "utilisation",
            "title": "Utilisation",
            "see": "",
            "description": "Margin utilisation shows how much cash and cash-equivalent assets have been used to offset margin."
        },
        totalCash: {
            "name": "totalCash",
            "title": "Total Cash",
            "see": "",
            "description": "The total of cash and cash-equivalent assets, including any applicable collateral and CMT balances."
        }
    });
}
